import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Facebook, Twitter, Instagram, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-950 text-gray-400 py-12 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white text-lg font-bold mb-4">IRON HAWK GHANA</h3>
            <p className="mb-4 max-w-xs">
              {t('hero.subtitle')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-sky-500 transition-colors"><Facebook className="h-5 w-5" /></a>
              <a href="#" className="text-gray-400 hover:text-sky-500 transition-colors"><Twitter className="h-5 w-5" /></a>
              <a href="#" className="text-gray-400 hover:text-sky-500 transition-colors"><Instagram className="h-5 w-5" /></a>
            </div>
          </div>
          
          <div>
            <h3 className="text-white text-lg font-bold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-sky-500" />
                <a href="mailto:support@ironhawkgh.com" className="hover:text-white">support@ironhawkgh.com</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-sky-500" />
                <span>+233 277549999</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-sky-500" />
                <span>Accra, Ghana</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-900 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Iron Hawk Ghana. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>);

};

export default Footer;